<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="confirm-modal-container"
    title="確認"
  >
    <template v-slot:body="{ cancel, ok }">
      <v-card-text class="pa-0">
        <v-container>
          <div v-if="cpaIdInformationSeq">
            指定されたファイルをダウンロードします。よろしいですか？<br />ダウンロードしたファイルは一覧から削除されます。
          </div>
          <div v-else>選択されたファイルを削除します。よろしいですか？</div>
          <div v-if="isWarning">
            <span v-if="cpaIdInformationSeq" class="text-red"
              >※当ファイルはお客様が作成したファイルですので、ご注意下さい。</span
            >
            <span v-else class="text-red"
              >※お客様が作成したファイルを含んでおりますので、ご注意下さい。</span
            >
          </div>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              v-if="cpaIdInformationSeq"
              :href="
                $api.cpaIdApi.downloadCpaAccountCsvURL(cpaIdInformationSeq)
              "
              variant="flat"
              color="primary"
              @click="ok"
            >
              はい
            </v-btn>
            <v-btn v-else variant="flat" color="primary" @click="ok">
              はい
            </v-btn>
            <v-btn variant="outlined" color="outline-primary" @click="cancel"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { AuthorityType } from "@/apis/CpaIdApi";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "CpaIdFileDownloadConfirm",
  props: {
    // ダウンロード確認の場合のみ指定あり
    cpaIdInformationSeq: {
      type: String as PropType<string>,
      required: false,
    },
    authorityType: {
      type: String as PropType<AuthorityType>,
      required: true,
    },
  },
  computed: {
    // 代行権限でログインしている且つ、ダウンロード対象ファイルが法人権限で作成されいるかチェック
    isWarning(): boolean {
      return (
        this.$service.permission.isDelegateUser() &&
        this.authorityType === "CUSTOMER"
      );
    },
  },
  methods: {
    async ok() {
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
